import { render, staticRenderFns } from "./TeacherAdditionalWorkModal.vue?vue&type=template&id=358af3ca"
import script from "./TeacherAdditionalWorkModal.vue?vue&type=script&lang=js"
export * from "./TeacherAdditionalWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports